import React, {useEffect, useContext} from "react";
import { useParams, useHistory } from "react-router-dom";
import { Spinner, Button, Card } from "../../../lib/components";
import useCultureQuizzInstance from "../../../hooks/useCultureQuizzInstance";
import { useFullscreen } from "rooks";
import {SidebarContext} from "../../../lib/context/dashboard/sidebar.context";
import styles from "assets/scss/pages/CutlureQuizz/QuizzStart.module.scss";

const QuizzStart = () => {
  const params = useParams();
  const history = useHistory();
  const {exit, request, isFullscreen} = useFullscreen();
  const [sidebarOpen, setSidebarOpen] = useContext(SidebarContext);

  const {
    loading,
    instance,
    quizz,
    registerParticipant,
    unRegisterParticipant
  } = useCultureQuizzInstance(params.uid);
  
  useEffect(()=> {
    if(!loading){
      registerParticipant();
    }
  },[loading]);

  
  const enterFullScreen = () => {
    if (!isFullscreen) request();
    if(sidebarOpen) setSidebarOpen(false);
  };

  const exitFullScreen = () => {
    if (isFullscreen) exit();
    if(!sidebarOpen) setSidebarOpen(true);
  };

  const exitQuiz = () => {
    exitFullScreen();
    unRegisterParticipant();
    history.push("/dashboard/cultureQuizz");
  };

  useEffect(() => {
    enterFullScreen();
  }, []);


  if (loading || !instance)
    return <Spinner />;

  return (
    <div style={{ position: "relative", width: "100%", height: "85vh", display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "center", gap: "15%"}}>
      {/* eslint-disable-next-line react/no-unescaped-entities*/}
      <h2 className={styles.h2}>Quiz "{quizz.title}"</h2>
      <h3 className={styles.h3}>En attente du début de la partie</h3>
      <Spinner size={"md"}/>

      <div style={{position: "absolute", zIndex: 1001, top: -95,left: "70px", right: "165px", height: "80px", display: "flex", justifyContent: "center"}}>
        <div style={{position: "relative", width: "95%", height: "100%", display: "flex", justifyContent: "flex-end", alignItems:"center", gap: 30}}>
          <Button color="danger" onClick={exitQuiz} style={{fontSize: "1.2vw", fontWeight:"bold"}}>Quitter le quiz</Button>
        </div>
      </div>
    </div>
  );
};

export default QuizzStart;